import { Navigate, useLocation } from 'react-router-dom';

import { usePrefetchAccounts } from '../features/accounts/queries';
import { useMe } from '../features/auth/queries';

import { AppShell } from './domain/AppShell';

export function RequireAuth() {
  const location = useLocation();
  const me = useMe();
  usePrefetchAccounts();

  if (me.isLoading) {
    return <div className="p-6 text-text-muted">Loading session...</div>;
  }

  if (me.isError) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <AppShell />;
}
